<template>
  <div v-for="({ title, values }, i) in prosAndCons" :key="i" class="b b-grey-50 px-4 py-6">
    <h3 class="mb-4 title-5">
      {{ title }}
    </h3>
    <ul class="space-y-2">
      <li v-for="({ label, count }, j) in values" :key="j" class="mb-2 flex">
        <span class="grow">{{ label }}</span>
        <span>{{ count }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { MappedProsAndCons } from '#types/components/product/reviews'

defineProps<{
  prosAndCons: MappedProsAndCons[]
}>()
</script>
